










import { Tabs, Tab, Sticky } from 'vant'
import { Component, Vue, Prop, Inject } from 'vue-property-decorator'
import RecommendTab from './recommend_tab.vue'
import { getSelectedCityId } from '@utils/index'

@Component({
  components: {
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Sticky.name]: Sticky,
    RecommendTab,
  },
})
export default class RecommendTabs extends Vue {
  @Prop() readonly tabKey!: number //监听变化 重新获取stickyForHeight
  @Prop() readonly location!: any
  @Prop() readonly stickyTop!: number //van-tabs吸顶的offsettop值 必须要传
  @Prop() readonly selectedBaby!: any
  @Prop() readonly templateType!: number
  @Prop({ default: () => [] }) readonly tabs!: any[]

  @Inject('pageTrackParams')
  pageTrackParams!: any
  @Inject('clickid_tab')
  clickid_tab!: string

  tabSelect = 0 //tab索引
  normalColor = 'transparent' //没有吸顶的背景色  吸顶后背景变成白色
  vanTab: HTMLElement | null = null

  mounted() {
    const el = this.$refs.tabs as any
    const doms = el.$el as HTMLDivElement
    const tabs = doms.getElementsByClassName('van-tabs__wrap')
    if (tabs.length > 0) {
      this.vanTab = tabs[0] as HTMLElement
    }
  }

  scrolling(params: any) {
    const { isFixed } = params
    if (isFixed) {
      this.normalColor = '#ffffff'
      if (this.vanTab) this.vanTab.style.boxShadow = '0 7px 14px 0 rgba(0, 0, 0, 0.03)'
    } else {
      this.normalColor = 'transparent'
      if (this.vanTab) this.vanTab.style.boxShadow = ''
    }
  }

  //跳转tab
  tabClicked() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_tab, positionParam: { citycode: getSelectedCityId(), tabname: this.tabs[this.tabSelect].tabName } })
  }
}
